import { RawHTML } from '@wordpress/element';

// @ts-ignore
const { registerCheckoutFilters } = window.wc.blocksCheckout;
// @ts-ignore
const {getSetting} = window.wc.wcSettings;

import {
    Coupon,
    DiscountSettings
} from './InterfactDiscountSettings';

const data: DiscountSettings = getSetting('dokan_vendor_discount_data');

function getDiscountCoupon( couponLabel: string, discountLabel: string ): JSX.Element {
    let newLabel = discountLabel ?? couponLabel;

    return <RawHTML>{newLabel}</RawHTML>
}

const getModifiedCoupon = ( coupon: Coupon ): Coupon => {
    const vendorCouponSetting = data?.couponSettings[coupon.code];
    const adminSetting = data?.settings;

    let label = coupon.label;

    // If order discount is applied change the label.
    if ( adminSetting?.orderDiscountEnabled && vendorCouponSetting?.hasDiscount && vendorCouponSetting?.orderDiscount?.hasApplied ) {
        label = getDiscountCoupon( coupon.label, vendorCouponSetting?.orderDiscount?.label );
    // Of product discount is applied change the label.
    } else if ( adminSetting?.productDiscountEnabled && vendorCouponSetting?.hasDiscount && vendorCouponSetting?.productDiscount?.hasApplied ) {
        label = getDiscountCoupon( coupon.label, vendorCouponSetting?.productDiscount?.label );
    }

    return {
        ...coupon,
        label
    };
}

const modifyCoupons = ( coupons: Coupon[], extensions, args ) => {
    return coupons.map( ( coupon ) => {
        return getModifiedCoupon(coupon);
    } );
};

registerCheckoutFilters( 'dokan_vendor_discount', {
    coupons: modifyCoupons,
} );
